import { Controller } from "@hotwired/stimulus";
import OffcanvasService from "../services/offcanvas_service";
import ConfirmationModalService from "../services/confirmation_modal_service";

export default class extends Controller {
  static targets = ["form"];

  connect() {
    OffcanvasService.reset(this.element);
  }

  hide() {
    OffcanvasService.hide();
  }

  clearForm({ params: { message } }) {
    ConfirmationModalService.show(message).then(() => {
      $("input[type=text], input[type=number]", this.formTarget).val("");
    });
  }

  resetForm({ params: { message } }) {
    ConfirmationModalService.show(message).then(() => {
      this.formTarget.reset();
    });
  }

  handleSubmit(event) {
    if (event.detail.success) {
      this.hide();
    }
  }
}
